const DarkTheme = {
  palette: {
    mode: 'dark',
    divider: 'rgba(255, 255, 255, 0.15)',
    text: {
      primary: 'rgba(255, 255, 255, 0.9)',
      secondary: 'rgba(255, 255, 255, 0.6)',
      disabled: 'rgba(255, 255, 255, 0.5)',
      contrast: '#000000',
    },
    background: {
      default: '#111111',
      paper: '#1e1e1e',
      overlay: 'rgba(255, 255, 255, 0.06)',
      backdrop: 'rgba(0, 0, 0, 0.3)',
    },
    primary: {
      lighter: '#881052',
      light: '#DB238A',
      main: '#E75AA8',
      dark: '#f8a0d0',
      contrastText: '#fff',
    },
    secondary: {
      lighter: '#434343',
      light: '#a6a6a6',
      main: '#eaeaea',
      dark: '#ffffff',
      contrastText: '#000',
    },
    error: {
      lighter: '#502825',
      light: '#b03725',
      main: '#dd3f27',
      dark: '#e9664d',
      contrastText: '#fff',
    },
    warning: {
      lighter: '#423117',
      light: '#9a731a',
      main: '#dda116',
      dark: '#eabd44',
      contrastText: '#1e1e1e',
    },
    info: {
      lighter: '#112123',
      light: '#146262',
      main: '#13a8a8',
      dark: '#58d1c9',
      contrastText: '#fff',
    },
    success: {
      lighter: '#162312',
      light: '#306317',
      main: '#49aa19',
      dark: '#8fd460',
      contrastText: '#fff',
    },
    grey: {
      0: '#000000',
      50: '#141414',
      100: '#1e1e1e',
      200: '#595959',
      300: '#8c8c8c',
      400: '#bfbfbf',
      500: '#d9d9d9',
      600: '#f0f0f0',
      700: '#f5f5f5',
      800: '#fafafa',
      900: '#ffffff',
    },
    brand: {
      blue: '#53b3e4',
      green: '#8ac541',
      purple: '#a576a7',
      yellow: '#fdd106',
      gray: '#707272',
      magenta: '#DB238A',
      black: '#000000',
    },
    tag: {
      secondary: {
        light: '#2f2f2f',
        dark: '#adb3c0',
      },
      success: {
        light: '#215242',
        dark: '#19d7a0',
      },
      warning: {
        light: '#4d3c2b',
        dark: '#ffa327',
      },
      error: {
        light: '#5a1c1c',
        dark: '#ff7878',
      },
      errorFilled: {
        light: '#eb5757',
        dark: '#3b0c0c',
      },
      errorFilledPurple: {
        light: '#a576a7',
        dark: '#fff3ff',
      },
      info: {
        light: '#1b2e4c',
        dark: '#5f88e3',
      },
      infoFilled: {
        light: '#3a4b5e',
        dark: '#cbd6e2',
      },
    },
  },
}

export default DarkTheme
